import { Link } from 'react-router-dom';
import { motion, useMotionValueEvent, useScroll } from "framer-motion";
import { useState, useEffect} from "react";
// import logo from '../assets/logo.svg';
import Theme from '../components/Theme'

function Header(){

    // -- scroll control
    const parentVariants = {
        visible: { opacity: 1, y: 0 },
        hidden: { opacity: 0, y: "-4rem" },
    };
    
    const { scrollY } = useScroll();
    const [hidden, setHidden] = useState(false);
    const [prevScroll, setPrevScroll] = useState(0);

    const [showBg, setShowBg] = useState(false);

    function update(latest: number, prev: number): void {
        // if (latest < prev) {
        // setHidden(false);
        // // console.log("visible");
        // } else if (latest > 100 && latest > prev) {
        // setHidden(true);
        // // console.log("hidden");
        // }
         if (latest < prev) {
            setHidden(false);
            setShowBg(true); // 上スクロール時は背景オン
        } else if (latest > 100 && latest > prev) {
            setHidden(true);
        }
    }

    useMotionValueEvent(scrollY, "change", (latest: number) => {
        update(latest, prevScroll);
        setPrevScroll(latest);
    });

    useEffect(() => {
        if (showBg) {
            const timer = setTimeout(() => setShowBg(false), 3000); // 2秒後に透明
            return () => clearTimeout(timer);
        }
    }, [showBg]);
    // --

    return (
        <motion.nav
            // className="navStyles"
            className={`navStyles ${showBg ? "with-bg" : "transparent"}`}
            variants={parentVariants}
            animate={hidden ? "hidden" : "visible"}
            transition={{
                ease: [0.1, 0.25, 0.3, 1],
                duration: 0.6,
                staggerChildren: 0.05,
            }}
        >
            
            <div className='header-bracket'>
                <div></div>
                <div></div>
            </div>
            <div className='header-container'>
                <div className='menu-logo-container'>
                    {/* <Link to="./"><div className='logo'></div></Link> */}
                    <p className='logo'>
                        <Link to="./">NATSUMI H.</Link>
                    </p>
                        {/* <Link to="./"><img src={logo} alt='logo' /></Link> */}
                    {/* <div className='header-title'>
                        <p>Natsumi H.</p>
                        <p>Motion Designer / Creative Developer</p>
                    </div> */}
                </div>
                <div className='menu-container'>
                    <div className='menu-list'>
                        <Link to="./about"><p>ABOUT</p></Link> 
                    </div>
                    <div className='menu-list'>
                        <Link to="./works"><p>WORKS</p></Link> 
                    </div> 
                    <div className='menu-list'>
                        <Link to="./lab"><p>LAB</p></Link> 
                    </div> 
                    <Theme />
                </div>
            </div>
        </motion.nav>
    );
}
export default Header;